export enum FileType {
  Csv = 'text/csv',
  Text = 'plain/text',
  Json = 'application/json',
  Pdf = 'application/pdf'
}

interface Params {
  content: string | Blob
  type: FileType
}

export function download(name: string, params: Params) {
  const blob = new Blob([params.content], { type: params.type })

  // Create blob link to download

  const tmpLink = document.createElement('a')
  tmpLink.href = window.URL.createObjectURL(blob)
  tmpLink.setAttribute('download', name)

  // Append to html link element page
  document.body.appendChild(tmpLink)

  // Start download
  tmpLink.click()

  // Clean up and remove the link
  tmpLink?.parentNode?.removeChild(tmpLink)
}
